import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    height: 650
  }
}))
export default useStyles
